
const removeDangerMessage = () => {
    const questions = document.getElementsByClassName('question-section__alert-message__show');
    for(const element of questions) {
        element.classList.remove('question-section__alert-message__show');
    }
}

export default removeDangerMessage;